const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/utils.ts';
import { FieldPathModifier } from './types';
import _ from 'lodash';

export const createFieldPath = (basePath: string, fieldPath: string, fieldPathModifier?: FieldPathModifier) => {
    return [basePath, fieldPathModifier ? fieldPathModifier(fieldPath) : fieldPath].join('.');
};

/**
 * Generates a type-safe map of field paths from a base path and a list of keys.
 * The returned object is typed as `Record<T[number], string>`, enabling IDE autocomplete
 * for all keys when the array is passed with `as const`.
 *
 * @param basePath - The base path prefix for all generated field paths.
 * @param pathKeys - A readonly tuple of field key names. Must be passed with `as const` to preserve literal types.
 * @returns A record mapping each key to its full field path.
 *
 * @example
 * const PATHS = generatePaths(path, ['employment', 'company', 'country', 'tel'] as const);
 *
 * PATHS.employment // → full field path string, with autocomplete
 * PATHS.company    // → full field path string, with autocomplete
 */
export const generatePaths = <T extends readonly string[]>(basePath: string, pathKeys: T): Record<T[number], string> =>
    Object.fromEntries(pathKeys.map((key) => [key, createFieldPath(basePath, key)])) as Record<T[number], string>;

export const fieldValueIsNot = (formData: any, path: string, values: (string | undefined)[]) => {
    // Set result to false if any value matches formData[path]
    const fieldValue = _.get(formData, path);
    return !values.includes(fieldValue);
};
